import { render, staticRenderFns } from "./Shipings.vue?vue&type=template&id=7170722a"
import script from "./Shipings.vue?vue&type=script&lang=js"
export * from "./Shipings.vue?vue&type=script&lang=js"
import style0 from "./Shipings.vue?vue&type=style&index=0&id=7170722a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports